import { FC, useEffect, useState } from 'react';
import IcoArrow from '@/assets/svg/ico_arrow.svg?react';
import Button from '@/components/controls/Button/Button.component';
import { SCROLL_THRESHOLD } from '@/components/elems/ScrollToTopButton/ScrollToTopButton.config';
import styles from '@/components/elems/ScrollToTopButton/ScrollToTopButton.module.scss';

const ScrollToTopButton: FC = () => {
    const [isVisible, setIsVisible] = useState<boolean>(false);

    useEffect(() => {
        const handleScroll = (): void => {
            setIsVisible(window.scrollY > SCROLL_THRESHOLD);
        };

        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <div className={styles.scrollToTopButtonWrapper}>
            <Button
                isCustom
                className={`flc ${styles.button} ${isVisible ? styles.visible : ''}`}
                clickHandler={() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
                dataTest="scroll_to_top_button"
                icon={<IcoArrow />}
            />
        </div>
    );
};

export default ScrollToTopButton;
